import { IDocumentWorkingCopy } from '../models/document-working-copy.model';

const ZERO_UUID = '00000000-0000-0000-0000-000000000000';

export function hasWorkingCopyId(
  workingCopy: Pick<IDocumentWorkingCopy, 'id'> | null | undefined
): workingCopy is IDocumentWorkingCopy & { id: string } {
  const id = workingCopy?.id;
  return !!id && id !== ZERO_UUID;
}
